/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as LayoutRouteImport } from "./routes/_layout"
import { Route as LayoutIndexRouteImport } from "./routes/_layout/index"
import { Route as LayoutSwapRouteImport } from "./routes/_layout/swap"
import { Route as LayoutRewardsRouteImport } from "./routes/_layout/rewards"
import { Route as LayoutPortfolioRouteImport } from "./routes/_layout/portfolio"
import { Route as LayoutDiscoverRouteImport } from "./routes/_layout/discover"
import { Route as LayoutDefiRouteImport } from "./routes/_layout/defi"
import { Route as LayoutRewardsIndexRouteImport } from "./routes/_layout/rewards.index"
import { Route as LayoutPortfolioIndexRouteImport } from "./routes/_layout/portfolio.index"
import { Route as LayoutDefiIndexRouteImport } from "./routes/_layout/defi.index"
import { Route as LayoutRewardsPositionsRouteImport } from "./routes/_layout/rewards.positions"
import { Route as LayoutRewardsIdleRouteImport } from "./routes/_layout/rewards.idle"
import { Route as LayoutRewardsActivityRouteImport } from "./routes/_layout/rewards.activity"
import { Route as LayoutRewardsAssetRouteImport } from "./routes/_layout/rewards.$asset"
import { Route as LayoutPortfolioBreakdownRouteImport } from "./routes/_layout/portfolio.breakdown"
import { Route as LayoutPortfolioAssetsRouteImport } from "./routes/_layout/portfolio.assets"
import { Route as LayoutDefiStablecoinsRouteImport } from "./routes/_layout/defi.stablecoins"
import { Route as LayoutDefiProtocolsRouteImport } from "./routes/_layout/defi.protocols"
import { Route as LayoutDefiPortfolioRouteImport } from "./routes/_layout/defi.portfolio"
import { Route as LayoutDefiStablecoinsIndexRouteImport } from "./routes/_layout/defi.stablecoins.index"
import { Route as LayoutDefiProtocolsIndexRouteImport } from "./routes/_layout/defi.protocols.index"
import { Route as LayoutDefiPortfolioIndexRouteImport } from "./routes/_layout/defi.portfolio.index"
import { Route as LayoutDefiProtocolsProtocolKeyRouteImport } from "./routes/_layout/defi.protocols.$protocolKey"
import { Route as LayoutDefiPortfolioPositionsRouteImport } from "./routes/_layout/defi.portfolio.positions"
import { Route as LayoutDefiPortfolioOpportunitiesRouteImport } from "./routes/_layout/defi.portfolio.opportunities"
import { Route as LayoutRewardsAssetStakeVaultRouteImport } from "./routes/_layout/rewards.$asset.stake.$vault"
import { Route as LayoutDefiPoolTokenAddressProtocolIdRouteImport } from "./routes/_layout/defi.pool.$tokenAddress.$protocolId"

const LayoutRoute = LayoutRouteImport.update({
  id: "/_layout",
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSwapRoute = LayoutSwapRouteImport.update({
  id: "/swap",
  path: "/swap",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutRewardsRoute = LayoutRewardsRouteImport.update({
  id: "/rewards",
  path: "/rewards",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPortfolioRoute = LayoutPortfolioRouteImport.update({
  id: "/portfolio",
  path: "/portfolio",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDiscoverRoute = LayoutDiscoverRouteImport.update({
  id: "/discover",
  path: "/discover",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDefiRoute = LayoutDefiRouteImport.update({
  id: "/defi",
  path: "/defi",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutRewardsIndexRoute = LayoutRewardsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutRewardsRoute,
} as any)
const LayoutPortfolioIndexRoute = LayoutPortfolioIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutPortfolioRoute,
} as any)
const LayoutDefiIndexRoute = LayoutDefiIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutDefiRoute,
} as any)
const LayoutRewardsPositionsRoute = LayoutRewardsPositionsRouteImport.update({
  id: "/positions",
  path: "/positions",
  getParentRoute: () => LayoutRewardsRoute,
} as any)
const LayoutRewardsIdleRoute = LayoutRewardsIdleRouteImport.update({
  id: "/idle",
  path: "/idle",
  getParentRoute: () => LayoutRewardsRoute,
} as any)
const LayoutRewardsActivityRoute = LayoutRewardsActivityRouteImport.update({
  id: "/activity",
  path: "/activity",
  getParentRoute: () => LayoutRewardsRoute,
} as any)
const LayoutRewardsAssetRoute = LayoutRewardsAssetRouteImport.update({
  id: "/$asset",
  path: "/$asset",
  getParentRoute: () => LayoutRewardsRoute,
} as any)
const LayoutPortfolioBreakdownRoute =
  LayoutPortfolioBreakdownRouteImport.update({
    id: "/breakdown",
    path: "/breakdown",
    getParentRoute: () => LayoutPortfolioRoute,
  } as any)
const LayoutPortfolioAssetsRoute = LayoutPortfolioAssetsRouteImport.update({
  id: "/assets",
  path: "/assets",
  getParentRoute: () => LayoutPortfolioRoute,
} as any)
const LayoutDefiStablecoinsRoute = LayoutDefiStablecoinsRouteImport.update({
  id: "/stablecoins",
  path: "/stablecoins",
  getParentRoute: () => LayoutDefiRoute,
} as any)
const LayoutDefiProtocolsRoute = LayoutDefiProtocolsRouteImport.update({
  id: "/protocols",
  path: "/protocols",
  getParentRoute: () => LayoutDefiRoute,
} as any)
const LayoutDefiPortfolioRoute = LayoutDefiPortfolioRouteImport.update({
  id: "/portfolio",
  path: "/portfolio",
  getParentRoute: () => LayoutDefiRoute,
} as any)
const LayoutDefiStablecoinsIndexRoute =
  LayoutDefiStablecoinsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutDefiStablecoinsRoute,
  } as any)
const LayoutDefiProtocolsIndexRoute =
  LayoutDefiProtocolsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutDefiProtocolsRoute,
  } as any)
const LayoutDefiPortfolioIndexRoute =
  LayoutDefiPortfolioIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutDefiPortfolioRoute,
  } as any)
const LayoutDefiProtocolsProtocolKeyRoute =
  LayoutDefiProtocolsProtocolKeyRouteImport.update({
    id: "/$protocolKey",
    path: "/$protocolKey",
    getParentRoute: () => LayoutDefiProtocolsRoute,
  } as any)
const LayoutDefiPortfolioPositionsRoute =
  LayoutDefiPortfolioPositionsRouteImport.update({
    id: "/positions",
    path: "/positions",
    getParentRoute: () => LayoutDefiPortfolioRoute,
  } as any)
const LayoutDefiPortfolioOpportunitiesRoute =
  LayoutDefiPortfolioOpportunitiesRouteImport.update({
    id: "/opportunities",
    path: "/opportunities",
    getParentRoute: () => LayoutDefiPortfolioRoute,
  } as any)
const LayoutRewardsAssetStakeVaultRoute =
  LayoutRewardsAssetStakeVaultRouteImport.update({
    id: "/stake/$vault",
    path: "/stake/$vault",
    getParentRoute: () => LayoutRewardsAssetRoute,
  } as any)
const LayoutDefiPoolTokenAddressProtocolIdRoute =
  LayoutDefiPoolTokenAddressProtocolIdRouteImport.update({
    id: "/pool/$tokenAddress/$protocolId",
    path: "/pool/$tokenAddress/$protocolId",
    getParentRoute: () => LayoutDefiRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/defi": typeof LayoutDefiRouteWithChildren
  "/discover": typeof LayoutDiscoverRoute
  "/portfolio": typeof LayoutPortfolioRouteWithChildren
  "/rewards": typeof LayoutRewardsRouteWithChildren
  "/swap": typeof LayoutSwapRoute
  "/": typeof LayoutIndexRoute
  "/defi/portfolio": typeof LayoutDefiPortfolioRouteWithChildren
  "/defi/protocols": typeof LayoutDefiProtocolsRouteWithChildren
  "/defi/stablecoins": typeof LayoutDefiStablecoinsRouteWithChildren
  "/portfolio/assets": typeof LayoutPortfolioAssetsRoute
  "/portfolio/breakdown": typeof LayoutPortfolioBreakdownRoute
  "/rewards/$asset": typeof LayoutRewardsAssetRouteWithChildren
  "/rewards/activity": typeof LayoutRewardsActivityRoute
  "/rewards/idle": typeof LayoutRewardsIdleRoute
  "/rewards/positions": typeof LayoutRewardsPositionsRoute
  "/defi/": typeof LayoutDefiIndexRoute
  "/portfolio/": typeof LayoutPortfolioIndexRoute
  "/rewards/": typeof LayoutRewardsIndexRoute
  "/defi/portfolio/opportunities": typeof LayoutDefiPortfolioOpportunitiesRoute
  "/defi/portfolio/positions": typeof LayoutDefiPortfolioPositionsRoute
  "/defi/protocols/$protocolKey": typeof LayoutDefiProtocolsProtocolKeyRoute
  "/defi/portfolio/": typeof LayoutDefiPortfolioIndexRoute
  "/defi/protocols/": typeof LayoutDefiProtocolsIndexRoute
  "/defi/stablecoins/": typeof LayoutDefiStablecoinsIndexRoute
  "/defi/pool/$tokenAddress/$protocolId": typeof LayoutDefiPoolTokenAddressProtocolIdRoute
  "/rewards/$asset/stake/$vault": typeof LayoutRewardsAssetStakeVaultRoute
}
export interface FileRoutesByTo {
  "/discover": typeof LayoutDiscoverRoute
  "/swap": typeof LayoutSwapRoute
  "/": typeof LayoutIndexRoute
  "/portfolio/assets": typeof LayoutPortfolioAssetsRoute
  "/portfolio/breakdown": typeof LayoutPortfolioBreakdownRoute
  "/rewards/$asset": typeof LayoutRewardsAssetRouteWithChildren
  "/rewards/activity": typeof LayoutRewardsActivityRoute
  "/rewards/idle": typeof LayoutRewardsIdleRoute
  "/rewards/positions": typeof LayoutRewardsPositionsRoute
  "/defi": typeof LayoutDefiIndexRoute
  "/portfolio": typeof LayoutPortfolioIndexRoute
  "/rewards": typeof LayoutRewardsIndexRoute
  "/defi/portfolio/opportunities": typeof LayoutDefiPortfolioOpportunitiesRoute
  "/defi/portfolio/positions": typeof LayoutDefiPortfolioPositionsRoute
  "/defi/protocols/$protocolKey": typeof LayoutDefiProtocolsProtocolKeyRoute
  "/defi/portfolio": typeof LayoutDefiPortfolioIndexRoute
  "/defi/protocols": typeof LayoutDefiProtocolsIndexRoute
  "/defi/stablecoins": typeof LayoutDefiStablecoinsIndexRoute
  "/defi/pool/$tokenAddress/$protocolId": typeof LayoutDefiPoolTokenAddressProtocolIdRoute
  "/rewards/$asset/stake/$vault": typeof LayoutRewardsAssetStakeVaultRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_layout": typeof LayoutRouteWithChildren
  "/_layout/defi": typeof LayoutDefiRouteWithChildren
  "/_layout/discover": typeof LayoutDiscoverRoute
  "/_layout/portfolio": typeof LayoutPortfolioRouteWithChildren
  "/_layout/rewards": typeof LayoutRewardsRouteWithChildren
  "/_layout/swap": typeof LayoutSwapRoute
  "/_layout/": typeof LayoutIndexRoute
  "/_layout/defi/portfolio": typeof LayoutDefiPortfolioRouteWithChildren
  "/_layout/defi/protocols": typeof LayoutDefiProtocolsRouteWithChildren
  "/_layout/defi/stablecoins": typeof LayoutDefiStablecoinsRouteWithChildren
  "/_layout/portfolio/assets": typeof LayoutPortfolioAssetsRoute
  "/_layout/portfolio/breakdown": typeof LayoutPortfolioBreakdownRoute
  "/_layout/rewards/$asset": typeof LayoutRewardsAssetRouteWithChildren
  "/_layout/rewards/activity": typeof LayoutRewardsActivityRoute
  "/_layout/rewards/idle": typeof LayoutRewardsIdleRoute
  "/_layout/rewards/positions": typeof LayoutRewardsPositionsRoute
  "/_layout/defi/": typeof LayoutDefiIndexRoute
  "/_layout/portfolio/": typeof LayoutPortfolioIndexRoute
  "/_layout/rewards/": typeof LayoutRewardsIndexRoute
  "/_layout/defi/portfolio/opportunities": typeof LayoutDefiPortfolioOpportunitiesRoute
  "/_layout/defi/portfolio/positions": typeof LayoutDefiPortfolioPositionsRoute
  "/_layout/defi/protocols/$protocolKey": typeof LayoutDefiProtocolsProtocolKeyRoute
  "/_layout/defi/portfolio/": typeof LayoutDefiPortfolioIndexRoute
  "/_layout/defi/protocols/": typeof LayoutDefiProtocolsIndexRoute
  "/_layout/defi/stablecoins/": typeof LayoutDefiStablecoinsIndexRoute
  "/_layout/defi/pool/$tokenAddress/$protocolId": typeof LayoutDefiPoolTokenAddressProtocolIdRoute
  "/_layout/rewards/$asset/stake/$vault": typeof LayoutRewardsAssetStakeVaultRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/defi"
    | "/discover"
    | "/portfolio"
    | "/rewards"
    | "/swap"
    | "/"
    | "/defi/portfolio"
    | "/defi/protocols"
    | "/defi/stablecoins"
    | "/portfolio/assets"
    | "/portfolio/breakdown"
    | "/rewards/$asset"
    | "/rewards/activity"
    | "/rewards/idle"
    | "/rewards/positions"
    | "/defi/"
    | "/portfolio/"
    | "/rewards/"
    | "/defi/portfolio/opportunities"
    | "/defi/portfolio/positions"
    | "/defi/protocols/$protocolKey"
    | "/defi/portfolio/"
    | "/defi/protocols/"
    | "/defi/stablecoins/"
    | "/defi/pool/$tokenAddress/$protocolId"
    | "/rewards/$asset/stake/$vault"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/discover"
    | "/swap"
    | "/"
    | "/portfolio/assets"
    | "/portfolio/breakdown"
    | "/rewards/$asset"
    | "/rewards/activity"
    | "/rewards/idle"
    | "/rewards/positions"
    | "/defi"
    | "/portfolio"
    | "/rewards"
    | "/defi/portfolio/opportunities"
    | "/defi/portfolio/positions"
    | "/defi/protocols/$protocolKey"
    | "/defi/portfolio"
    | "/defi/protocols"
    | "/defi/stablecoins"
    | "/defi/pool/$tokenAddress/$protocolId"
    | "/rewards/$asset/stake/$vault"
  id:
    | "__root__"
    | "/_layout"
    | "/_layout/defi"
    | "/_layout/discover"
    | "/_layout/portfolio"
    | "/_layout/rewards"
    | "/_layout/swap"
    | "/_layout/"
    | "/_layout/defi/portfolio"
    | "/_layout/defi/protocols"
    | "/_layout/defi/stablecoins"
    | "/_layout/portfolio/assets"
    | "/_layout/portfolio/breakdown"
    | "/_layout/rewards/$asset"
    | "/_layout/rewards/activity"
    | "/_layout/rewards/idle"
    | "/_layout/rewards/positions"
    | "/_layout/defi/"
    | "/_layout/portfolio/"
    | "/_layout/rewards/"
    | "/_layout/defi/portfolio/opportunities"
    | "/_layout/defi/portfolio/positions"
    | "/_layout/defi/protocols/$protocolKey"
    | "/_layout/defi/portfolio/"
    | "/_layout/defi/protocols/"
    | "/_layout/defi/stablecoins/"
    | "/_layout/defi/pool/$tokenAddress/$protocolId"
    | "/_layout/rewards/$asset/stake/$vault"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_layout": {
      id: "/_layout"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_layout/": {
      id: "/_layout/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/swap": {
      id: "/_layout/swap"
      path: "/swap"
      fullPath: "/swap"
      preLoaderRoute: typeof LayoutSwapRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/rewards": {
      id: "/_layout/rewards"
      path: "/rewards"
      fullPath: "/rewards"
      preLoaderRoute: typeof LayoutRewardsRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/portfolio": {
      id: "/_layout/portfolio"
      path: "/portfolio"
      fullPath: "/portfolio"
      preLoaderRoute: typeof LayoutPortfolioRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/discover": {
      id: "/_layout/discover"
      path: "/discover"
      fullPath: "/discover"
      preLoaderRoute: typeof LayoutDiscoverRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/defi": {
      id: "/_layout/defi"
      path: "/defi"
      fullPath: "/defi"
      preLoaderRoute: typeof LayoutDefiRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/rewards/": {
      id: "/_layout/rewards/"
      path: "/"
      fullPath: "/rewards/"
      preLoaderRoute: typeof LayoutRewardsIndexRouteImport
      parentRoute: typeof LayoutRewardsRoute
    }
    "/_layout/portfolio/": {
      id: "/_layout/portfolio/"
      path: "/"
      fullPath: "/portfolio/"
      preLoaderRoute: typeof LayoutPortfolioIndexRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    "/_layout/defi/": {
      id: "/_layout/defi/"
      path: "/"
      fullPath: "/defi/"
      preLoaderRoute: typeof LayoutDefiIndexRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
    "/_layout/rewards/positions": {
      id: "/_layout/rewards/positions"
      path: "/positions"
      fullPath: "/rewards/positions"
      preLoaderRoute: typeof LayoutRewardsPositionsRouteImport
      parentRoute: typeof LayoutRewardsRoute
    }
    "/_layout/rewards/idle": {
      id: "/_layout/rewards/idle"
      path: "/idle"
      fullPath: "/rewards/idle"
      preLoaderRoute: typeof LayoutRewardsIdleRouteImport
      parentRoute: typeof LayoutRewardsRoute
    }
    "/_layout/rewards/activity": {
      id: "/_layout/rewards/activity"
      path: "/activity"
      fullPath: "/rewards/activity"
      preLoaderRoute: typeof LayoutRewardsActivityRouteImport
      parentRoute: typeof LayoutRewardsRoute
    }
    "/_layout/rewards/$asset": {
      id: "/_layout/rewards/$asset"
      path: "/$asset"
      fullPath: "/rewards/$asset"
      preLoaderRoute: typeof LayoutRewardsAssetRouteImport
      parentRoute: typeof LayoutRewardsRoute
    }
    "/_layout/portfolio/breakdown": {
      id: "/_layout/portfolio/breakdown"
      path: "/breakdown"
      fullPath: "/portfolio/breakdown"
      preLoaderRoute: typeof LayoutPortfolioBreakdownRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    "/_layout/portfolio/assets": {
      id: "/_layout/portfolio/assets"
      path: "/assets"
      fullPath: "/portfolio/assets"
      preLoaderRoute: typeof LayoutPortfolioAssetsRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    "/_layout/defi/stablecoins": {
      id: "/_layout/defi/stablecoins"
      path: "/stablecoins"
      fullPath: "/defi/stablecoins"
      preLoaderRoute: typeof LayoutDefiStablecoinsRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
    "/_layout/defi/protocols": {
      id: "/_layout/defi/protocols"
      path: "/protocols"
      fullPath: "/defi/protocols"
      preLoaderRoute: typeof LayoutDefiProtocolsRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
    "/_layout/defi/portfolio": {
      id: "/_layout/defi/portfolio"
      path: "/portfolio"
      fullPath: "/defi/portfolio"
      preLoaderRoute: typeof LayoutDefiPortfolioRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
    "/_layout/defi/stablecoins/": {
      id: "/_layout/defi/stablecoins/"
      path: "/"
      fullPath: "/defi/stablecoins/"
      preLoaderRoute: typeof LayoutDefiStablecoinsIndexRouteImport
      parentRoute: typeof LayoutDefiStablecoinsRoute
    }
    "/_layout/defi/protocols/": {
      id: "/_layout/defi/protocols/"
      path: "/"
      fullPath: "/defi/protocols/"
      preLoaderRoute: typeof LayoutDefiProtocolsIndexRouteImport
      parentRoute: typeof LayoutDefiProtocolsRoute
    }
    "/_layout/defi/portfolio/": {
      id: "/_layout/defi/portfolio/"
      path: "/"
      fullPath: "/defi/portfolio/"
      preLoaderRoute: typeof LayoutDefiPortfolioIndexRouteImport
      parentRoute: typeof LayoutDefiPortfolioRoute
    }
    "/_layout/defi/protocols/$protocolKey": {
      id: "/_layout/defi/protocols/$protocolKey"
      path: "/$protocolKey"
      fullPath: "/defi/protocols/$protocolKey"
      preLoaderRoute: typeof LayoutDefiProtocolsProtocolKeyRouteImport
      parentRoute: typeof LayoutDefiProtocolsRoute
    }
    "/_layout/defi/portfolio/positions": {
      id: "/_layout/defi/portfolio/positions"
      path: "/positions"
      fullPath: "/defi/portfolio/positions"
      preLoaderRoute: typeof LayoutDefiPortfolioPositionsRouteImport
      parentRoute: typeof LayoutDefiPortfolioRoute
    }
    "/_layout/defi/portfolio/opportunities": {
      id: "/_layout/defi/portfolio/opportunities"
      path: "/opportunities"
      fullPath: "/defi/portfolio/opportunities"
      preLoaderRoute: typeof LayoutDefiPortfolioOpportunitiesRouteImport
      parentRoute: typeof LayoutDefiPortfolioRoute
    }
    "/_layout/rewards/$asset/stake/$vault": {
      id: "/_layout/rewards/$asset/stake/$vault"
      path: "/stake/$vault"
      fullPath: "/rewards/$asset/stake/$vault"
      preLoaderRoute: typeof LayoutRewardsAssetStakeVaultRouteImport
      parentRoute: typeof LayoutRewardsAssetRoute
    }
    "/_layout/defi/pool/$tokenAddress/$protocolId": {
      id: "/_layout/defi/pool/$tokenAddress/$protocolId"
      path: "/pool/$tokenAddress/$protocolId"
      fullPath: "/defi/pool/$tokenAddress/$protocolId"
      preLoaderRoute: typeof LayoutDefiPoolTokenAddressProtocolIdRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
  }
}

interface LayoutDefiPortfolioRouteChildren {
  LayoutDefiPortfolioOpportunitiesRoute: typeof LayoutDefiPortfolioOpportunitiesRoute
  LayoutDefiPortfolioPositionsRoute: typeof LayoutDefiPortfolioPositionsRoute
  LayoutDefiPortfolioIndexRoute: typeof LayoutDefiPortfolioIndexRoute
}

const LayoutDefiPortfolioRouteChildren: LayoutDefiPortfolioRouteChildren = {
  LayoutDefiPortfolioOpportunitiesRoute: LayoutDefiPortfolioOpportunitiesRoute,
  LayoutDefiPortfolioPositionsRoute: LayoutDefiPortfolioPositionsRoute,
  LayoutDefiPortfolioIndexRoute: LayoutDefiPortfolioIndexRoute,
}

const LayoutDefiPortfolioRouteWithChildren =
  LayoutDefiPortfolioRoute._addFileChildren(LayoutDefiPortfolioRouteChildren)

interface LayoutDefiProtocolsRouteChildren {
  LayoutDefiProtocolsProtocolKeyRoute: typeof LayoutDefiProtocolsProtocolKeyRoute
  LayoutDefiProtocolsIndexRoute: typeof LayoutDefiProtocolsIndexRoute
}

const LayoutDefiProtocolsRouteChildren: LayoutDefiProtocolsRouteChildren = {
  LayoutDefiProtocolsProtocolKeyRoute: LayoutDefiProtocolsProtocolKeyRoute,
  LayoutDefiProtocolsIndexRoute: LayoutDefiProtocolsIndexRoute,
}

const LayoutDefiProtocolsRouteWithChildren =
  LayoutDefiProtocolsRoute._addFileChildren(LayoutDefiProtocolsRouteChildren)

interface LayoutDefiStablecoinsRouteChildren {
  LayoutDefiStablecoinsIndexRoute: typeof LayoutDefiStablecoinsIndexRoute
}

const LayoutDefiStablecoinsRouteChildren: LayoutDefiStablecoinsRouteChildren = {
  LayoutDefiStablecoinsIndexRoute: LayoutDefiStablecoinsIndexRoute,
}

const LayoutDefiStablecoinsRouteWithChildren =
  LayoutDefiStablecoinsRoute._addFileChildren(
    LayoutDefiStablecoinsRouteChildren,
  )

interface LayoutDefiRouteChildren {
  LayoutDefiPortfolioRoute: typeof LayoutDefiPortfolioRouteWithChildren
  LayoutDefiProtocolsRoute: typeof LayoutDefiProtocolsRouteWithChildren
  LayoutDefiStablecoinsRoute: typeof LayoutDefiStablecoinsRouteWithChildren
  LayoutDefiIndexRoute: typeof LayoutDefiIndexRoute
  LayoutDefiPoolTokenAddressProtocolIdRoute: typeof LayoutDefiPoolTokenAddressProtocolIdRoute
}

const LayoutDefiRouteChildren: LayoutDefiRouteChildren = {
  LayoutDefiPortfolioRoute: LayoutDefiPortfolioRouteWithChildren,
  LayoutDefiProtocolsRoute: LayoutDefiProtocolsRouteWithChildren,
  LayoutDefiStablecoinsRoute: LayoutDefiStablecoinsRouteWithChildren,
  LayoutDefiIndexRoute: LayoutDefiIndexRoute,
  LayoutDefiPoolTokenAddressProtocolIdRoute:
    LayoutDefiPoolTokenAddressProtocolIdRoute,
}

const LayoutDefiRouteWithChildren = LayoutDefiRoute._addFileChildren(
  LayoutDefiRouteChildren,
)

interface LayoutPortfolioRouteChildren {
  LayoutPortfolioAssetsRoute: typeof LayoutPortfolioAssetsRoute
  LayoutPortfolioBreakdownRoute: typeof LayoutPortfolioBreakdownRoute
  LayoutPortfolioIndexRoute: typeof LayoutPortfolioIndexRoute
}

const LayoutPortfolioRouteChildren: LayoutPortfolioRouteChildren = {
  LayoutPortfolioAssetsRoute: LayoutPortfolioAssetsRoute,
  LayoutPortfolioBreakdownRoute: LayoutPortfolioBreakdownRoute,
  LayoutPortfolioIndexRoute: LayoutPortfolioIndexRoute,
}

const LayoutPortfolioRouteWithChildren = LayoutPortfolioRoute._addFileChildren(
  LayoutPortfolioRouteChildren,
)

interface LayoutRewardsAssetRouteChildren {
  LayoutRewardsAssetStakeVaultRoute: typeof LayoutRewardsAssetStakeVaultRoute
}

const LayoutRewardsAssetRouteChildren: LayoutRewardsAssetRouteChildren = {
  LayoutRewardsAssetStakeVaultRoute: LayoutRewardsAssetStakeVaultRoute,
}

const LayoutRewardsAssetRouteWithChildren =
  LayoutRewardsAssetRoute._addFileChildren(LayoutRewardsAssetRouteChildren)

interface LayoutRewardsRouteChildren {
  LayoutRewardsAssetRoute: typeof LayoutRewardsAssetRouteWithChildren
  LayoutRewardsActivityRoute: typeof LayoutRewardsActivityRoute
  LayoutRewardsIdleRoute: typeof LayoutRewardsIdleRoute
  LayoutRewardsPositionsRoute: typeof LayoutRewardsPositionsRoute
  LayoutRewardsIndexRoute: typeof LayoutRewardsIndexRoute
}

const LayoutRewardsRouteChildren: LayoutRewardsRouteChildren = {
  LayoutRewardsAssetRoute: LayoutRewardsAssetRouteWithChildren,
  LayoutRewardsActivityRoute: LayoutRewardsActivityRoute,
  LayoutRewardsIdleRoute: LayoutRewardsIdleRoute,
  LayoutRewardsPositionsRoute: LayoutRewardsPositionsRoute,
  LayoutRewardsIndexRoute: LayoutRewardsIndexRoute,
}

const LayoutRewardsRouteWithChildren = LayoutRewardsRoute._addFileChildren(
  LayoutRewardsRouteChildren,
)

interface LayoutRouteChildren {
  LayoutDefiRoute: typeof LayoutDefiRouteWithChildren
  LayoutDiscoverRoute: typeof LayoutDiscoverRoute
  LayoutPortfolioRoute: typeof LayoutPortfolioRouteWithChildren
  LayoutRewardsRoute: typeof LayoutRewardsRouteWithChildren
  LayoutSwapRoute: typeof LayoutSwapRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutDefiRoute: LayoutDefiRouteWithChildren,
  LayoutDiscoverRoute: LayoutDiscoverRoute,
  LayoutPortfolioRoute: LayoutPortfolioRouteWithChildren,
  LayoutRewardsRoute: LayoutRewardsRouteWithChildren,
  LayoutSwapRoute: LayoutSwapRoute,
  LayoutIndexRoute: LayoutIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
